/* AUTEUR PDP, purchase mode.

   The radios are named selling_plan and live inside the product form, so the
   cart is correct with this file absent: Shopify reads the checked radio on
   submit whether or not any script ran. Everything here is presentation.

   Two jobs:
   1. Keep the add-to-bag price in step with the chosen cadence.
   2. Mirror the choice into the sticky bar's separate form, which would
      otherwise always add a one-off no matter what the visitor picked. That is
      the kind of bug that does not look like a bug, it just quietly bills the
      wrong thing. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var root = document.querySelector('[data-buy-modes]');
    if (!root) return;

    var radios = Array.prototype.slice.call(root.querySelectorAll('input[name="selling_plan"]'));
    if (!radios.length) return;

    var priceOut = document.querySelectorAll('[data-atc-price]');
    var stickyInputs = document.querySelectorAll('[data-sticky-plan]');
    var stickyPrice = document.querySelectorAll('[data-sticky-price]');

    function apply() {
      var chosen = null;
      for (var i = 0; i < radios.length; i++) if (radios[i].checked) chosen = radios[i];
      if (!chosen) return;

      var money = chosen.getAttribute('data-price');
      for (var j = 0; j < priceOut.length; j++) {
        if (money) priceOut[j].textContent = money;
      }
      for (var k = 0; k < stickyPrice.length; k++) {
        if (money) stickyPrice[k].textContent = money;
      }
      for (var n = 0; n < stickyInputs.length; n++) {
        stickyInputs[n].value = chosen.value || '';
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', apply); });
    apply();
  });
})();
